import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const propertiesPageReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {

    default:
      return state;
  }
};
